import { render, staticRenderFns } from "./CallBox.vue?vue&type=template&id=4e77f31d&scoped=true"
import script from "./CallBox.vue?vue&type=script&lang=js"
export * from "./CallBox.vue?vue&type=script&lang=js"
import style0 from "./CallBox.vue?vue&type=style&index=0&id=4e77f31d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e77f31d",
  null
  
)

export default component.exports